export enum SLOTS_WITH_FALLBACK_ENUM {
    banner = 'banner',
    rectangle = 'rectangle',
    topmobile = 'topmobile',
    teaser = 'teaser',
    mobile_teaser = 'mobile_teaser',
}
export interface AdDetails {
    url: string
    rectangle: string
    banner: string
    topmobile: string
    androidLink?: string
    iOSLink?: string
}

const fallbacksHrefs = {
    dopaOnTour: 'https://www.printyourticket.de/Tour/DOPPELPASS-11559.html',
    bayernNewsletter: 'https://www.sport1.de/news/unternehmen/2023/08/newsletter-fc-bayern-munchen',
    bvbNewsletter: 'https://www.sport1.de/news/unternehmen/2023/08/newsletter-borussia-dortmund',
    dartsNewsletter: 'https://www.sport1.de/news/unternehmen/2023/08/newsletter-anmeldungen-2023',
    sport1AppAndroid:
        'https://play.google.com/store/apps/details?id=sport1.mobile.android.apps&hl=de',
    sport1AppIos: 'https://apps.apple.com/de/app/sport1-sport-fussball-news/id300000385',
}

const fallbackSizes = {
    [SLOTS_WITH_FALLBACK_ENUM.rectangle]: { width: '300px', height: '250px' },
    [SLOTS_WITH_FALLBACK_ENUM.topmobile]: { width: '320px', height: '50px' },
    [SLOTS_WITH_FALLBACK_ENUM.banner]: { width: '728px', height: '90px' },
}

const adFallbacks: AdDetails[] = [
    {
        url: fallbacksHrefs.dopaOnTour,
        rectangle: 'https://reshape.sport1.de/c/t/a019d153-5137-469a-94b5-3226d14ab1f6/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/db29fa3d-6560-4fe5-a47c-3aac479cc2ec/0x0',
        banner: 'https://reshape.sport1.de/c/t/d8f91972-f9f3-4cfd-942e-1a0c7ae93c9a/0x0',
    },
    {
        url: fallbacksHrefs.bayernNewsletter,
        rectangle: 'https://reshape.sport1.de/c/t/96472158-8edf-4c34-b6b2-68e2c4776ea9/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/bb18e9b8-cc98-4d96-8e63-3379fc83c73a/0x0',
        banner: 'https://reshape.sport1.de/c/t/c8f43938-26c1-406c-ade1-da5ffb18a4fe/0x0',
    },
    {
        url: fallbacksHrefs.bvbNewsletter,
        rectangle: 'https://reshape.sport1.de/c/t/0519d64c-27e5-4902-abd1-3178105a7869/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/303450d7-075f-4fd7-bd05-fc01f1c4b3e9/0x0',
        banner: 'https://reshape.sport1.de/c/t/a5648d64-bd2e-42aa-82be-79dc42cd75e1/0x0',
    },
    {
        url: fallbacksHrefs.dartsNewsletter,
        rectangle: 'https://reshape.sport1.de/c/t/e0718312-7761-44e3-b7b4-aa3b417a8df8/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/f2226e0d-27c8-41f1-9ad9-814777aaecb9/0x0',
        banner: 'https://reshape.sport1.de/c/t/cc3ddaaa-ce5b-4765-9877-e734ac7b9168/0x0',
    },
    {
        url: '',
        androidLink: fallbacksHrefs.sport1AppAndroid,
        iOSLink: fallbacksHrefs.sport1AppIos,
        rectangle: 'https://reshape.sport1.de/c/t/58abb0fb-0996-484f-9c0d-f3ae1e700803/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/49955f5c-54bd-45fe-a264-3818c07f4d39/0x0',
        banner: 'https://reshape.sport1.de/c/t/e020c99e-c265-46fb-a54f-e534a49a741b/0x0',
    },
    {
        url: '',
        androidLink: fallbacksHrefs.sport1AppAndroid,
        iOSLink: fallbacksHrefs.sport1AppIos,
        rectangle: 'https://reshape.sport1.de/c/t/cd5cb91c-7760-4753-be07-f6dc51b3b4f0/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/10f716f3-f7c0-4b7a-abac-708d11807159/0x0',
        banner: 'https://reshape.sport1.de/c/t/9ddc8a0e-5c2b-4ae3-a6cc-0ba372749225/0x0',
    },
]

export { adFallbacks, fallbackSizes }
